import React from 'react'
import axios from 'axios'
import { API_HOST } from '../lib/xhr'
import { Formik, Field, Form } from 'formik'
import { CurrencyMask, Checkbox, PhoneMask, MultiSelectMenu } from '../forms/components'
import Navigation from '../components/Navigation'

let LottiePlayer = (async () => {
  if (typeof window !== 'undefined') {
    await import("@lottiefiles/lottie-player")
  }
})()

// const FORM_SUBMISSION_URI = API_HOST + '/api/v2/forms/liloclean/contact'

const encode = (data) => {
  return Object.keys(data)
  .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
  .join("&")
}

const post_form = async (values) => {
  return await axios({
    method: 'POST',
    url: '/',
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    data: encode({ "form-name": "contact", ...values })
  })
  .then(() => {
    window.location = '/thankyou'
    return true
  })
  .catch(err => {
    alert(err)
    return false
  })
}

const ContactView = ({ model,  cats, menu_state }) => {

  const panel = model && model.panel !== undefined ? model.panel : null
  const page = model ? model : { name: '', Body: ''}

  return (
    <div id="contact-view" className="view">
      <header style={{ minHeight: 0 }}>
        <div className={menu_state}>
          <div className="py-2 bg-darkazul bg-opacity-80 text-white text-xl">
            <Navigation link_cls="hover:text-ice font-medium" />
          </div>
        </div>
        <div className="container pt-20 lg:pt-24 px-4 lg:px-0">
          <h1 className="text-center text-darkazul text-5xl font-light">{page.name}</h1>
        </div>
      </header>
      <main id="contact" className="text-texgray">
        <div className="container">
          <p className="py-12 text-center">{page.Body}</p>
          <div className="px-4 md:px-0">
            <Formik
              initialValues={{
                name: '',
                company: '',
                email: '',
                phone: '',
                products: [],
                time: '',
                credit: '',
                optin: []
              }}
              onSubmit={(values, { setSubmitting }) => {
                setSubmitting(post_form(values))
              }}
            >
              {({ isSubmitting, errors, values }) => {
                const default_btn_class = "w-full btn btn-primary"
                const btn_class = isSubmitting ? (default_btn_class + " disabled") : default_btn_class
                return (
                  <Form>
                    {
                      isSubmitting ?
                      <div className="border px-4 py-3 mb-6 rounded" role="alert">
                        <span className="block sm:inline">Thanks! Our sales team will reaching out to you soon.</span>
                      </div>
                      : null
                    }
                    <div className="no-flex lg:flex">
                      <div className="w-full lg:w-1/2 md:items-center mb-6 mr-6">
                        <div className="w-full">
                          <label className="block uppercase mb-1 pr-4" htmlFor="field-name">
                            Full Name *
                          </label>
                        </div>
                        <div className="w-full">
                          <Field className="input-field" id="field-name" name="name" type="text" required />
                        </div>
                      </div>
                      <div className="w-full lg:w-1/2 md:items-center mb-6">
                        <div className="w-full">
                          <label className="block uppercase mb-1 pr-4" htmlFor="field-company">
                            Company Name
                          </label>
                        </div>
                        <div className="w-full">
                          <Field className="input-field" id="field-company" name="company" type="text" />
                        </div>
                      </div>
                    </div>
                    <div className="no-flex lg:flex">
                      <div className="w-full lg:w-1/2 md:items-center mb-6 mr-6">
                        <div className="w-full">
                          <label className="block uppercase mb-1 pr-4" htmlFor="field-email">
                            E-mail *
                          </label>
                        </div>
                        <div className="w-full">
                          <Field className="input-field" id="field-email" name="email" type="email" placeholder="jane.doe@company.com" required />
                        </div>
                      </div>
                      <div className="w-full lg:w-1/2 md:items-center mb-6">
                        <div className="w-full">
                          <label className="block uppercase mb-1 pr-4" htmlFor="field-phone">
                            Phone *
                          </label>
                        </div>
                        <div className="w-full">
                          <Field className="input-field" id="field-phone" name="phone" component={PhoneMask} required />
                        </div>
                      </div>
                    </div>
                    <div className="no-flex lg:flex">
                      <div className="w-full lg:w-1/2 md:items-center mb-6 mr-6">
                        <div className="w-full">
                          <label className="block uppercase mb-1 pr-4" htmlFor="field-products">
                            Products *
                          </label>
                        </div>
                        <div className="w-full">
                          <Field className="input-field" id="field-products" name="products" label="Products..." options={
                            cats.map(cat => (cat.name))
                          } component={MultiSelectMenu} required />
                        </div>
                      </div>
                      <div className="w-full lg:w-1/2 md:items-center mb-6">
                        <div className="w-full">
                          <label className="block uppercase mb-1 pr-4" htmlFor="field-time">
                            Lead Time *
                          </label>
                        </div>
                        <div className="w-full">
                          <Field className="input-field" id="field-time" name="time" type="text" required />
                        </div>
                      </div>
                    </div>
                    <div className="no-flex lg:flex">
                      <div className="w-full lg:w-1/2 md:items-center mb-6 mr-6">
                        <div className="w-full">
                          <label className="block uppercase mb-1 pr-4" htmlFor="field-credit">
                            Credit Amount Requested *
                          </label>
                        </div>
                        <div className="w-full">
                          <Field className="input-field" id="field-credit" name="credit" component={CurrencyMask} required />
                        </div>
                      </div>
                      <div className="w-full lg:w-1/2 md:items-center mb-6">
                        <div className="w-full">
                          <div className="block uppercase mb-1 pr-4">
                            &nbsp;
                          </div>
                        </div>
                        <div className="w-full">
                          <button className={btn_class} type="submit" disabled={isSubmitting}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="">
                      <div className="w-full mb-2">
                        OPT IN to correspondences via phone messages and correspondences via email. <Field name="optin" component={Checkbox} value={true} />
                      </div>
                      <div className="w-full mb-6">
                        * Required fields
                      </div>
                    </div>
                  </Form>
                )
              }}
            </Formik>
          </div>
        </div>
        <div className="flex items-stretch">
          <div className="flex-grow">&nbsp;</div>
          <div className="self-auto">
            {page.lottiefile ? <lottie-player src={page.lottiefile}  background="transparent"  speed="1"  style={{ height: 'auto', width: '100%' }}  loop  autoplay></lottie-player> : page.photo !== undefined ? <img id="the-team" src={API_HOST + page.photo.url} alt={page.photo.name} /> : null}
          </div>
          <div className="flex-grow">&nbsp;</div>
        </div>
        {
          panel ?
          <div className="text-white bg-azul">
            <div className="container flex flex-wrap px-4 lg:px-0">
              <div className="w-full">
                <div className="py-20 font-light text-center text-3xl">
                  {panel.body.split("\n").map((s, key) => {
                    return <span key={'rtf-' + key}>{s}<br /></span>
                  })}
                </div>
              </div>
            </div>
          </div>
          : null
        }
      </main>
    </div>
  )
}

export default ContactView